module.exports = __webpack_public_path__ + "assets/pdf.c49537db.svg";